<template>
  <div v-if="hasMap" class="description-map" id="map">
    <l-map :zoom="computedZoom" :center="[lat, lng]">
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="[lat, lng]">
        <l-popup> {{ markerPopupText }}</l-popup>
      </l-marker>
    </l-map>
  </div>
</template>
<script>
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet'

export default {
  props: {
    hasMap: {
      type: Boolean,
      required: true,
    },
    lat: {
      type: Number,
      required: true,
    },
    lng: {
      type: Number,
      required: true,
    },
    zoom: {
      type: Number,
      default: 8,
    },
    title: {
      type: String,
      default: '',
    },
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
    }
  },
  computed: {
    computedZoom() {
      return this.zoom ? this.zoom : 8
    },
    markerPopupText() {
      return this.title
    },
  },
}
</script>

<style scoped>
.description-map {
  width: 100%;
  height: 250px;
}
</style>
